import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '../Components/Typography';
//import TextField from '../Components/TextField';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';

function Copyright() {
	return (
		<React.Fragment>
			{'© '}
			<Link color="inherit" href="https://google.com/">
				Website Name
			</Link>{' '}
			2022 - {new Date().getFullYear()}
		</React.Fragment>
	);
}

const iconStyle = {
	width: 48,
	height: 48,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: 'warning.main',
	mr: 1,
	'&:hover': {
		bgcolor: 'warning.dark',
	},
};

export default function AppFooter() {
	return (
		<Typography
			component="footer"
			sx={{ display: 'flex', bgcolor: 'secondary.light' }}
		>
			<Container sx={{ my: 8, display: 'flex' }}>
				<Grid container spacing={5}>
					<Grid item xs={6} sm={4} md={3}>
						<Grid
							container
							direction="column"
							justifyContent="flex-end"
							spacing={2}
							sx={{ height: 120 }}
						>
							<Grid item sx={{ display: 'flex' }}>
								<Box
									component="a"
									href="https://facebook.com/"
									sx={iconStyle}
								>
									<FacebookIcon />
								</Box>
								<Box
									component="a"
									href="https://twitter.com/"
									sx={iconStyle}
								>
									<TwitterIcon />
								</Box>
							</Grid>
							<Grid item>
								<Copyright />
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<Typography variant="h6" marked="left" gutterBottom>
							Legal
						</Typography>
						<Box
							component="ul"
							sx={{ m: 0, listStyle: 'none', p: 0 }}
						>
							<Box component="li" sx={{ py: 0.5 }}>
								<Link href="/terms">Terms</Link>
							</Box>
							<Box component="li" sx={{ py: 0.5 }}>
								<Link href="/privacy">Privacy</Link>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</Typography>
	);
}
